import { useEffect, useState } from "react";
import { Footer, NavBar } from "@/components/ui";
import { Hero } from "./hero";
import { HowItWorks } from "./how-it-works";
import { Features } from "./features";
import { PricingPlans } from "./pricing-plans";
import { Developers } from "./developer";
import { Faq } from "./faq";
import Loader from "@/components/custom/Loader";
import "../../index.css";

const Home = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer); // cleanup
  }, []);

  return (
    <div>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <>
          <NavBar />
          <Hero />
          <HowItWorks />
          <Features />
          <PricingPlans />
          <Developers />
          <Faq />
          <Footer />
        </>
      )}
    </div>
  );
};

export default Home;
